import React from "react";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useNavigate } from "react-router-dom";
import RegionForm from "./regionComponents/RegionForm";
import { useCreateRegionMutation } from "store/services/LocationsApi/regionApi";
import { toast } from "react-toastify";

const RegionCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Province", path: "/app/crm/region/list" },
    { title: "New Province" },
  ];

  const [createRegion, { isLoading: creatingRegion, error }] =
    useCreateRegionMutation();

  const handleRegionCreate = async (data) => {
    try {
      await createRegion({
        ...data,
        country: data.country?._id,
      }).unwrap();
      navigate(breadcrumbs[0].path);
      toast.success("Province created successfully");
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Province!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingRegion}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <RegionForm isBusy={creatingRegion} onSubmit={handleRegionCreate} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default RegionCreateScreen;
